import { render } from "./WorkerEditDialog.vue?vue&type=template&id=91ecc3c6"
import script from "./WorkerEditDialog.vue?vue&type=script&lang=js"
export * from "./WorkerEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__